import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Alert,
  Divider,
  Box,
  Button,
  Snackbar,
  Alert as MuiAlert,
  List,
  ListItem,
} from "@mui/material";
import getApiBase from "../components/getApiBase";// ✅ This is your backend URL file

const InviteList = ({ shopId }) => {
  const [invites, setInvites] = useState([]);
  const [inactiveMechanics, setInactiveMechanics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(""); // ✅ Success message state
  const [loadingApproveId, setLoadingApproveId] = useState(null);

  const fetchInactiveMechanics = async () => {
    try {
      const res = await fetch(`${getApiBase()}/api/mechanic/inactive`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!res.ok) throw new Error("Failed to fetch inactive mechanics");

      const data = await res.json();
      setInactiveMechanics(data);
    } catch (err) {
      console.error("❌ Error fetching inactive mechanics:", err);
    }
  };

  useEffect(() => {
    const fetchInvites = async () => {
      try {
        const res = await fetch(
          `${getApiBase()}/api/invite/list?shopId=${shopId}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );

        if (!res.ok) throw new Error("Network response was not ok");

        const data = await res.json();
        setInvites(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load invites");
      } finally {
        setLoading(false);
      }
    };

    if (shopId) {
      fetchInvites();
      fetchInactiveMechanics(); // ✅ Load inactive mechanics too
    }
  }, [shopId]);

  const handleApprove = async (mechanicId) => {
    setLoadingApproveId(mechanicId);
    try {
      const res = await fetch(`${getApiBase()}/api/mechanic/approve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ mechanicId }),
      });

      if (res.ok) {
        await fetchInactiveMechanics(); // ✅ Refresh list after approval
        setSuccess("✅ Mechanic approved successfully"); // ✅ Success message
      } else {
        const data = await res.json();
        setError(data.message || "❌ Failed to approve mechanic");
      }
    } catch (err) {
      console.error("❌ Error approving mechanic:", err);
      setError("❌ Server error while approving mechanic");
    } finally {
      setLoadingApproveId(null);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Paper sx={{ mt: 4, p: 2 }}>
      <Typography variant="h6" sx={{ mt: 4 }}>
        Mechanics Requesting to Join Shop
      </Typography>

      {inactiveMechanics.length === 0 ? (
        <Typography>No pending requests.</Typography>
      ) : (
        inactiveMechanics.map((mech) => (
          <Box
            key={mech.id}
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
            }}
          >
            <Box>
              <Typography fontWeight="bold">
                {mech.first_name} {mech.last_name}
              </Typography>
              <Typography variant="body2">{mech.email}</Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => handleApprove(mech.id)}
              disabled={loadingApproveId === mech.id}
            >
              {loadingApproveId === mech.id ? "Approving..." : "Approve"}
            </Button>
          </Box>
        ))
      )}

      <Divider sx={{ my: 4 }} />

      <Typography variant="h6" gutterBottom>
        Invited Mechanics
      </Typography>

      {/* ✅ Snackbar for success */}
      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={() => setSuccess("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          severity="success"
          variant="filled"
          onClose={() => setSuccess("")}
        >
          {success}
        </MuiAlert>
      </Snackbar>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {/* <Table>
        <TableHead>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Sent At</TableCell>
            <TableCell>Used At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invites.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No invites yet
              </TableCell>
            </TableRow>
          ) : (
            invites.map((invite) => (
              <TableRow key={invite.id}>
                <TableCell>{invite.email}</TableCell>
                <TableCell>{invite.status}</TableCell>
                <TableCell>
                  {new Date(invite.created_at).toLocaleString()}
                </TableCell>
                <TableCell>
                  {invite.used_at
                    ? new Date(invite.used_at).toLocaleString()
                    : "-"}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table> */}

      <List sx={{ display: "flex", flexDirection: "column" }}>
        {invites.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} align="center">
              No invites yet
            </TableCell>
          </TableRow>
        ) : (
          invites.map((invite) => (
            <ListItem
              key={invite.id}
              divider
              sx={{ display: "flex", fontSize: "14px", flexDirection: { xs: "column", lg: "row", } }}
            >
              <Box width={{ xs: "100%", lg: "50%", }} sx={{ display: "flex", flexDirection: { xs: "column", md: "row", }, }}>
                <Box width={{ xs: "100%", md: "50%", lg: "65%", }}><span className="red">Email:</span> {invite.email}</Box>
                <Box width={{ xs: "100%", md: "50%", lg: "35%", }}><span className="red">Status:</span> {invite.status}</Box>
              </Box>
              <Box width={{ xs: "100%", lg: "50%", }} sx={{ display: "flex", flexDirection: { xs: "column", md: "row", }, }}>
                <Box width={{ sm: "100%", md: "50%", }}>
                  <span className="red">Sent At:</span> {new Date(invite.created_at).toLocaleString()}
                </Box>
                <Box width={{ sm: "100%", md: "50%", }}>
                  <span className="red">Used At:</span>{" "}
                  {invite.used_at
                    ? new Date(invite.used_at).toLocaleString()
                    : "-"}
                </Box>
              </Box>
            </ListItem>
          ))
        )}
      </List>
    </Paper>
  );
};

export default InviteList;